export default {
  form: {
    amount: {
      label: 'Prix',
    },
    threshold: {
      label: 'Ventes mensuelles',
    },
    has_pricing_tiers: {
      label: 'Prix variable selon les ventes mensuelles',
    },
    tax_included: {
      label: 'Taxe incluse',
    },
  },
  buttons: {
    add_tier: 'Ajouter un palier',
  },
};
